import createMessage from "./createMessage";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";

const name = "cameraAndFlashlightState";

function create({ cameraId }) {
  return createMessage({
    [name]: CameraAndFlashlightState.create({ cameraId })
  });
}

export default {
  create,
  name
};

// message CameraAndFlashlightState {
//     bool flashlightAvailable = 1;
//     bool flashlightEnabled = 2;
//     bool flashlightAdjustable = 3;
//     float flashlightIntensity = 4;
//     string cameraId = 5; // nový parametr nesoucí id vybrané kamery
// }
